import { render, staticRenderFns } from "./ManualSlideNav.vue?vue&type=template&id=3c956422&scoped=true"
import script from "./ManualSlideNav.vue?vue&type=script&lang=js"
export * from "./ManualSlideNav.vue?vue&type=script&lang=js"
import style0 from "./ManualSlideNav.vue?vue&type=style&index=0&id=3c956422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c956422",
  null
  
)

export default component.exports